import React from 'react'

const Loader: React.FC = () => {
    return null
}

export default Loader
